"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";
export type ActionsProps = ComponentProps<"div">;
export const Actions = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("flex items-center gap-1 select-none", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <div className={t1} {...props}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export type ActionProps = ComponentProps<typeof Button> & {
  tooltip?: string;
  label?: string;
};
export const Action = t0 => {
  const $ = _c(26);
  let children;
  let className;
  let label;
  let props;
  let t1;
  let t2;
  let tooltip;
  if ($[0] !== t0) {
    ({
      tooltip,
      children,
      label,
      className,
      variant: t1,
      size: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = label;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = tooltip;
  } else {
    children = $[1];
    className = $[2];
    label = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    tooltip = $[7];
  }
  const variant = t1 === undefined ? "ghost" : t1;
  const size = t2 === undefined ? "sm" : t2;
  let t3;
  if ($[8] !== className) {
    t3 = cn("relative size-9 p-1.5 text-muted-foreground hover:text-foreground", className);
    $[8] = className;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = label ?? tooltip;
  let t5;
  if ($[10] !== t4) {
    t5 = <span className="sr-only">{t4}</span>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== children || $[13] !== props || $[14] !== size || $[15] !== t3 || $[16] !== t5 || $[17] !== variant) {
    t6 = <Button className={t3} size={size} type="button" variant={variant} {...props}>{children}{t5}</Button>;
    $[12] = children;
    $[13] = props;
    $[14] = size;
    $[15] = t3;
    $[16] = t5;
    $[17] = variant;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const button = t6;
  if (tooltip) {
    let t7;
    if ($[19] !== button) {
      t7 = <TooltipTrigger asChild={true}>{button}</TooltipTrigger>;
      $[19] = button;
      $[20] = t7;
    } else {
      t7 = $[20];
    }
    let t8;
    if ($[21] !== tooltip) {
      t8 = <TooltipContent><p>{tooltip}</p></TooltipContent>;
      $[21] = tooltip;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    let t9;
    if ($[23] !== t7 || $[24] !== t8) {
      t9 = <TooltipProvider><Tooltip>{t7}{t8}</Tooltip></TooltipProvider>;
      $[23] = t7;
      $[24] = t8;
      $[25] = t9;
    } else {
      t9 = $[25];
    }
    return t9;
  }
  return button;
};